// get google review count logic 
document.addEventListener('DOMContentLoaded', function () {
  const intervalTime = 500;
  const timeoutTime = 120000;

  const intervalId = setInterval(() => {
    const review = document.querySelector('.reputon-count-number');
    const links = document.querySelectorAll('.tro-hyper-link');

    // Wait until review exists AND at least one link exists
    if (review && links.length > 0) {
      links.forEach(link => {
        link.innerHTML = review.innerHTML;
      });

      clearInterval(intervalId);
      clearTimeout(timeoutId);
    }
  }, intervalTime);

  const timeoutId = setTimeout(() => {
    clearInterval(intervalId);
    console.warn('⏱ Timeout: elements not found');
  }, timeoutTime);
});
